import {
  mdiAccountClock,
  mdiAccountGroup,
  mdiAccountMultiple,
  mdiAccountMultiplePlus,
  mdiAccountPlus,
  mdiAccountSearch,
  mdiBookmark,
  mdiCommentTextMultiple,
  mdiHome,
  mdiHospitalBuilding,
  mdiEmailArrowRight
} from '@mdi/js'
import store from '@/store'

export default function getNavMenuItems() {
  const isScribeMode = !!store.state.auth.scribeProvider
  const userId = store.state.auth.user.id
  const unreadComments = store.state.comments.items.filter(x => !x.is_read && x.created_by_user_id !== userId).length

  const items = [
    { title: 'Home', icon: mdiHome, to: 'home' },
    { title: 'Facilities', icon: mdiHospitalBuilding, to: 'facilities' },
    { title: 'My Facilities Lists', icon: mdiBookmark, to: 'facilities-playlist' },

    // Only add Comments if not in scribe mode
    ...(!isScribeMode ? [{
      title: 'Comments',
      icon: mdiCommentTextMultiple,
      badge: unreadComments,
      badgeColor: 'error',
      to: 'list-comments',
    }] : []),

    { subheader: 'Patient Profiles' },
    { title: 'List Patient Profiles', icon: mdiAccountGroup, to: 'list-patients' },
    { title: 'Find Patient Profile', icon: mdiAccountSearch, to: { name: 'find-patient' } },
    { title: 'Create Patient Profile', icon: mdiAccountPlus, to: { name: 'add-patient' } },

    { subheader: 'Encounter Notes' },
    { title: 'List Encounters', icon: mdiAccountMultiple, to: 'list-encounters' },
    { title: 'Create Encounter', icon: mdiAccountMultiplePlus, to: 'encounter-patient-find' },
    { title: 'Communication Logs', icon: mdiEmailArrowRight, to: 'encounter-communication-log' },

    { subheader: 'Quick Entry' },
    { title: 'Quick Entry', icon: mdiAccountClock, to: 'quick-entry' },
  ]

  return items
}
